module.exports = __webpack_public_path__ + "img/tooltip_10-vallone-aure-wood-thermo-oak.4f1e3940.jpg";